import React from 'react'
import ReplacePlayerModal from './ReplacePlayerModal';
import LogExportModal from './LogExportModal';

type Props = {
    data: any;
    modalType: string;
    closeFunction: any;
}

function ModalFactoryGenerator({modalType,data,closeFunction}: Props) {
    const {section ,id,...info} = data
 switch (modalType) {
    case "replace_player":
      return <ReplacePlayerModal info={data} type={section} player_id={info.player_id} id={id} join_type={info.join_through} onClose={closeFunction}  />
    case "log_export":
      return <LogExportModal info={data}  id={id}  onClose={closeFunction}  />
    default:
      return <div>Wrong case</div>
  }
}

export default ModalFactoryGenerator